import {
  DrillthroughPostMessageTypes
} from 'cadenza/workbook/view/view-content/workbook-post-message-types';

/**
 * Post-message communication for drillthrough, drill-down and individual value table
 * dialogue on the iframe side.
 */
export class DrillthroughIframePostMessageApi {

  /** @type {import('cadenza/workbook/view-content/workbook-iframe-post-message-api').WorkbookIframePostMessageApi} */
  _workbookIFramePostMessageApi;

  /**
   * @param {import('cadenza/workbook/view-content/workbook-iframe-post-message-api').WorkbookIframePostMessageApi} workbookIFramePostMessageApi
   * @param {object} options - Additional (optional) options.
   */
  constructor (workbookIFramePostMessageApi, options = {}) {
    this._workbookIFramePostMessageApi = workbookIFramePostMessageApi;
  }

  /**
   * Shows the individual values table in a popup dialog with limited table functionality.
   *
   * @return {Promise<boolean|NoEndpointDefinedError>}
   *   A promise reflecting the receiving of the request on parent frame. First argument states the
   *   cancellation of the request by the recipient via event#preventDefault().
   */
  showIndividualValuesTableInDialog () {
    return this._workbookIFramePostMessageApi.request({
      type: DrillthroughPostMessageTypes.SHOW_INDIVIDUAL_VALUES_TABLE_IN_DIALOG
    });
  }

  /**
   * Informs the parent frame to drill down data view based on the current selection, like
   * drill-down hierarchical geometry Landkreis to Gemeinde level.
   *
   * @return {Promise<boolean|NoEndpointDefinedError>}
   *   A promise reflecting the receiving of the request on parent frame. First argument states the
   *   cancellation of the request by the recipient via event#preventDefault().
   */
  drillDown () {
    return this._workbookIFramePostMessageApi.request({
      type: DrillthroughPostMessageTypes.DRILL_DOWN
    });
  }

  openDrillThroughUrlDialogInWorkbookTopWindow (url, options) {
    return this._workbookIFramePostMessageApi.request({
      type: DrillthroughPostMessageTypes.OPEN_DRILL_THROUGH_URL_DIALOG,
      detail: { url, options }
    });
  }

  openDynamicDrillThrough (dataViewId, drillThrough, selectionIndex) {
    return this._workbookIFramePostMessageApi.request({
      type: DrillthroughPostMessageTypes.OPEN_DYNAMIC_DRILL_THROUGH,
      detail: { drillThrough, dataViewId, selectionIndex }
    });
  }

}
